module.exports = __webpack_public_path__ + "static/infinity-bd1d07e1de163f1ad5ceac9ac9b39b8b.svg";